module.exports = __webpack_public_path__ + "img/xxnl-logo-icon..614df6b4.png";